import type { ImportBalancesRepositoryT } from "../../domain/ports/importBalances.repository";
import type { ImportBalancesApiT, ImportBalancesMapperT } from "../types/importBalances.types";

import { extractErrorMessage } from "utils/extractErrorMessage";
import { BALANCES_STRINGS } from "../../constants/strings";

type ImportBalancesRepositoryParamsT = {
  importBalancesApi: ImportBalancesApiT;
  importBalancesMapper: ImportBalancesMapperT;
};

export const createImportBalancesRepository = ({
  importBalancesApi,
  importBalancesMapper,
}: ImportBalancesRepositoryParamsT): ImportBalancesRepositoryT => ({
  importBalances: async ({ colaboraInstanceId, typeId, mode, externalTypeId }) => {
    try {
      const response = await importBalancesApi.importBalances({
        colaboraInstanceId,
        typeId,
        mode,
        externalTypeId,
      });

      if (response.status !== 200) {
        throw new Error(BALANCES_STRINGS.IMPORT_ERROR_MESSAGE);
      }

      return importBalancesMapper.importBalancesDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(error, BALANCES_STRINGS.IMPORT_ERROR_MESSAGE);
      throw new Error(message);
    }
  },
});
